
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import FlightDeals from './components/FlightDeals';
import Services from './components/Services';
import Destinations from './components/Destinations';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <FlightDeals />
      <Services />
      <Destinations />
      <WhyChooseUs />
      <Testimonials />
      <Newsletter />
      <Footer />
    </div>
  );
}